import React from "react";

function WelcomeDegree() {
  return (
    <div className="mt-5 text-center">
      <h1>صفحة النتائج</h1>
      <h2>قم باختيار الفصل من اعلى</h2>
    </div>
  );
}

export default WelcomeDegree;
